var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasValidEntries)?_c('div',{staticClass:"helpful"},[_c('h3',[_vm._v("Hilfreiche Links")]),_c('ul',{staticClass:"helpful-links"},_vm._l((_vm.hilfreicheLinksArray),function(item,index){return _c('HelpfulLinks',{key:item.id,attrs:{"link":item}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }